// React
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { pick } from 'lodash'

// Components
import Select from 'ui/components/Select'

// Hooks
import { useFormikContext } from 'formik'

export const UserAddressesSelect = ({ addresses }) => {
  const [selectedAddress, setSelectedAddress] = useState(null)

  const form = useFormikContext()

  useEffect(() => {
    if (!addresses?.length) return

    // Select expecting it's own shape as value
    setSelectedAddress({
      value: addresses[0].id,
      label: addresses[0].value
    })
  }, [addresses])

  const options = addresses.map((address) => ({
    value: address.id,
    label: address.value
  }))

  const handleUserAddressSelect = (id) => {
    const option = options.find((option) => option.value === id)

    if (!option) return

    setSelectedAddress(option)

    const address = addresses.find((address) => address.id === id)

    if (!address) return

    form.setValues({
      ...form.values,
      data: {
        ...form.values.data,
        delivery_address_property_id: id
      },
      delivery_address: pick(address, [
        'address1',
        'address2',
        'zipcode',
        'city',
        'region',
        'province',
        'country',
        'country_id'
      ])
    })
  }

  return (
    <Select
      value={selectedAddress}
      options={options}
      onChange={handleUserAddressSelect}
      data-tid="User addresses select"
      forceValue
      forceOnChange
    />
  )
}

UserAddressesSelect.propTypes = {
  addresses: PropTypes.array
}
